import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconSymptomsTracker = props => {
  const { rootClassName, className, pencilClassName } = props;
  const classes = classNames(rootClassName || root, className);
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.375 12.75H5.125C5.37922 12.75 5.74994 13.0205 5.75 13.5713V21.4287C5.74994 21.9795 5.37922 22.25 5.125 22.25H2.375C2.12078 22.25 1.75006 21.9795 1.75 21.4287V13.5713C1.75006 13.0205 2.12078 12.75 2.375 12.75ZM10.625 6.46387H13.375C13.6292 6.46387 14 6.73527 14 7.28613V21.4287C13.9999 21.9795 13.6292 22.25 13.375 22.25H10.625C10.3708 22.25 10.0001 21.9795 10 21.4287V7.28613C10 6.73527 10.3708 6.46387 10.625 6.46387ZM18.875 1.75H21.625C21.8792 1.75 22.2499 2.02052 22.25 2.57129V21.4287C22.2499 21.9795 21.8792 22.25 21.625 22.25H18.875C18.6208 22.25 18.2501 21.9795 18.25 21.4287V2.57129C18.2501 2.02052 18.6208 1.75 18.875 1.75Z"
        stroke="#535763"
        strokeWidth="1.5"
      />
    </svg>
  );
};

IconSymptomsTracker.defaultProps = {
  rootClassName: null,
  className: null,
  pencilClassName: null,
};

const { string } = PropTypes;

IconSymptomsTracker.propTypes = {
  rootClassName: string,
  className: string,
  pencilClassName: string,
};

export default IconSymptomsTracker;
